/* 
 * 21.02.2018
 * NewCatController ile birlikte CategoryAndFilters.js yerine kullanılır
 * Infinity Scroll yerine Paging yapısına uygundur
 * $(document).ready 'nin üstünde bulunan fonksiyonlar açılışta çağrılır
 * $(document).ready 'nin altında bulunan fonksiyonlar event'lara bağlıdır, $(document).ready 'deki click olaylarıyla tetiklenir
 */

var date = new Date();
date.setTime(date.getTime() + (5 * 60 * 1000));
var themePath = "EALC";
var gridCookieName = themePath + "gridCookie";

function ToggleLeftBar() {
    if (!isMobileResolution()) {
        $(".FilterForm .filterLink").live("click", function () {
            $(".FilterForm .filterLink").not($(this)).addClass("toggle-minus");
            $(".FilterForm .FilterBoxes ul").not($(this).parent().find(".FilterBoxes ul")).removeClass("active");

            $(this).toggleClass("toggle-minus");
            //$(this).parent().find(".FilterBoxes ul").slideToggle();
            $(this).parent().find(".FilterBoxes ul").toggleClass("active");
        });
    }
    else {
        $(".FilterForm .filterLink").live("click", function () {
            $(".FilterForm .filterLink").not($(this)).addClass("toggle-minus");
            $(".FilterForm .FilterBoxes").not($(this).parent().find(".FilterBoxes")).removeClass("active");

            $(this).toggleClass("toggle-minus");
            $(this).parent().find(".FilterBoxes").toggleClass("active");
        });
    }
}

function SetPriceSlider() {
    var slider = document.getElementById('PriceSlider');

    if ($("#PgType").val() == "Cat" && slider != null) {

        var min = $("#MinPrice").val();
        var max = $("#MaxPrice").val();
        var currencySymbol = $("#CurrencySymbol").val();

        noUiSlider.create(slider, {
            start: [min, max],
            connect: true,
            step: 1,
            range: {
                'min': parseInt(min),
                'max': parseInt(max)
            }
        });

        slider.noUiSlider.on('change', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $("#SliderValue").val(Math.round(values[0]) + "-" + Math.round(values[1]));

            if (!isMobileResolution()) {
                //$(".AppylArea .FilterApplyButton").trigger("click");
                GetPageByFilter();
            }
        });

        slider.noUiSlider.on('update', function () {
            var values = slider.noUiSlider.get();
            $("#MinPrice").val(Math.round(values[0]));
            $("#MaxPrice").val(Math.round(values[1]));
            $(".priceView").html("").html(Math.round(values[0]) + " " + currencySymbol + "<span style='padding: 0px 40px;'></span> " + Math.round(values[1]) + " " + currencySymbol);
        });
    }
}

function LazyLoad() {
    $(".ProductList .Prd img.PImage, .ProductList .Prd .ProductListColor img").Lazy();

    HoverImage();
}

function HoverImage() {
    if (!isMobileResolution() && $(".ProductList .Prd").length > 0) {
        $(".ProductList .Prd .PrdImgsBox > .carousel.slide")
            .mouseover(function () {
                if ($(this).find(".carousel-item:first").hasClass("active")) {
                    $(this).find(".carousel-item:first").removeClass("active");
                    $(this).find(".carousel-item:last").addClass("active");

                    var activeImage = $(this).find(".carousel-item.active img");

                    if (activeImage.attr("data-img") != "") {
                        var img = activeImage.attr("data-img");
                        activeImage.attr("src", img).attr("data-img", "");
                    }
                }
            })
            .mouseout(function () {
                if ($(this).find(".carousel-item:last").hasClass("active")) {
                    $(this).find(".carousel-item:last").removeClass("active");
                    $(this).find(".carousel-item:first").addClass("active");
                }
            });
    }
}

// Cookie Değerine Göre Açılış Grid'ini Ayarlama Fonksiyonu
function SetGridByCookie() {
    var cookieGrid = $.cookie(gridCookieName);
    if (cookieGrid == "" || cookieGrid == null || cookieGrid == undefined) {
        cookieGrid = "5";
        $.cookie(gridCookieName, "5", { path: '/' }, { expires: 7 });
    }

    if (!isMobileResolution()) { // Desktop grid ayarlama
        DesktopGridSet(cookieGrid);
    }
    else { // Mobile grid ayarlama        
        MobileGridSet(cookieGrid);
    }
}

// Açılışta QueryString'deki Filtreleme Seçeneklerini Kontrol Eder
function QueryStringControlForFilter() {

    var vars = [], hash;
    var selectedSize = "";
    var selectedColor = "";
    var selectedCatalog = "";
    var selectedDepartment = "";
    var selectedSeason = "";
    var selectedPrice = "";
    var selectedSoldOut = "";
    var selectedSort = "";
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "s") {
                selectedSize = hash[1]; // Size değerleri alınır
            }
            else if (hash[0] == "c") {
                selectedColor = hash[1]; // Color değerleri alınır
            }
            else if (hash[0] == "ct") {
                selectedCatalog = hash[1]; // katalog değerleri alınır
            }
            else if (hash[0] == "dp") {
                selectedDepartment = hash[1]; // Departman değerleri alınır
            }
            else if (hash[0] == "sea") {
                selectedSeason = hash[1]; // Departman değerleri alınır
            }
            else if (hash[0] == "prc") {
                selectedPrice = hash[1]; // Price değerini alınır
            }
            else if (hash[0] == "so") {
                selectedSoldOut = hash[1]; // Tükenenleri Gizle seçeneğini alır
            }
            else if (hash[0] == "o") {
                selectedSort = hash[1]; // Sıralama seçeneği alınır
            }
        }

        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSize != null && selectedSize != "" && selectedSize != undefined) {
            var selectedSizes = selectedSize.split(',');

            $.each(selectedSizes, function (key, value) {
                $li = $("#Sizes li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Size'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedColor != null && selectedColor != "" && selectedColor != undefined) {
            var selectedColors = selectedColor.split(',');

            $.each(selectedColors, function (key, value) {
                $li = $("#Colors li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Color'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Katalog'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedCatalog != null && selectedCatalog != "" && selectedCatalog != undefined) {
            var selectedCatalogs = selectedCatalog.split(',');

            $.each(selectedCatalogs, function (key, value) {
                $li = $("#ProductGroup li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Katalog'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Departman'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedDepartment != null && selectedDepartment != "" && selectedDepartment != undefined) {
            var selectedDepartments = selectedDepartment.split(',');

            $.each(selectedDepartments, function (key, value) {
                $li = $("#Departments li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Departman'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar

        // Seçili Sezon'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        if (selectedSeason != null && selectedSeason != "" && selectedSeason != undefined) {
            var selectedSeasons = selectedSeason.split(',');

            $.each(selectedSeasons, function (key, value) {
                $li = $("#Seasons li input[value='" + value + "']").parent("li");
                FilterItemSelect($li);
            });
        }
        // Seçili Sezon'ların li'lerini FilterItemSelect fonksiyonuna göndererek işaretlenmesini sağlar
        
        // Seçili Price değer aralığını ayarlar
        if (selectedPrice != null && selectedPrice != "" && selectedPrice != undefined) {

            $("#SliderValue").val(selectedPrice);
            var SelectedPrices = selectedPrice.split('-');

            var slider = document.getElementById('PriceSlider');

            if (slider != null)
                slider.noUiSlider.set([SelectedPrices[0], SelectedPrices[1]]);
        }
        // Seçili Price değer aralığını ayarlar

        // Seçiliyse tükenenleri gizle seçeneğini işaretler
        if (selectedSoldOut != null && selectedSoldOut != "" && selectedSoldOut != undefined && selectedSoldOut == "1") {
            $li = $("#SoldOutOp li.gr");
            $li.find("input").attr("checked", "checked");
            $li.find("input").val("1");
            $li.find("label").addClass("checked2");
        }
        // Seçiliyse tükenenleri gizle seçeneğini işaretler

        // Sıralama varsa dropdown'dan seçeneği işaretler
        if (selectedSort != null && selectedSort != "" && selectedSort != undefined) {

            $li = $("#PrdSort input[value='" + selectedSort + "']").parent("li");

            $li.find("label").addClass("checked");
            $li.find("label").addClass("c_on");

            $(".fLinkSortNo").html($li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir
        }
        // Sıralama varsa dropdown'dan seçeneği işaretler
    }

    GetSelectedFilter(); // Gelen filtreleri Seçili Filtreler alanına ekler
}

// Seçimleriniz alanını footer'da gizler
function HideChoices() {
    $(window).scroll(function (event) {
        var y = $(this).scrollTop();
        var height = 0;

        $(".FilterForm .col-md-24").not(".AppylArea").each(function () {
            height += $(this).height();
        });

        height = height - 700;

        if (y >= height) {
            $(".AppylArea").removeClass("AppylAreaFixed");

        } else {
            $(".AppylArea").addClass("AppylAreaFixed");
        }
    });
}

// Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
function BackButtonLastScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var browserName = navigator.userAgent;
    if (browserName.indexOf("Chrome")) {
        browserName = "Chrome";
    }

    var pgType = $("#PgType").val();
    var lastScrollTop = $.cookie("lastScroll");
    var CatID = $("#PID").val();
    var lastScrollTopFirst = $.cookie("getLastScrollFirst");

    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

    if (pgType == "Cat") {

        if (CatID != $.cookie("lastCatalogID")) {
            lastScrollTopFirst = 0;
            $.cookie("lastCatalogID", CatID, { path: '/', expires: date });
        }

        if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
            if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {

                var listHeight = $(".ProductList").height();
                lastScrollTop = lastScrollTop - (listHeight /** (currentPage - 1)*/);

                if (lastScrollTop > 0) {
                    $('html, body').animate({
                        scrollTop: lastScrollTop
                    }, 0);
                }
            }
        }

        //if (NativeQueryFilter.indexOf("=") != "-1") { // kataloğun ilk sayfası ise lastScroll'u dikkate almasın
        //    if (lastScrollTop != null && lastScrollTop != "" && lastScrollTop != undefined && lastScrollTop > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTop
        //            }, 0);
        //        }, 1000);
        //    }
        //}
        //else {

        //    if (lastScrollTopFirst != null && lastScrollTopFirst != "" && lastScrollTopFirst != undefined && lastScrollTopFirst > 0) {
        //        setTimeout(function () {
        //            $('html, body').animate({
        //                scrollTop: lastScrollTopFirst
        //            }, 0);
        //        }, 1000);
        //    }
        //}

        $.cookie("getLastScrollFirst", "0", { path: '/', expires: date });
        $.cookie("lastScroll", "0", { path: '/', expires: date });
    }
}

function getPenPath() {
    var vars = [], hash;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder
    var currentPage = 1;

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                currentPage = hash[1];
            }
        }
    }

    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var params = "";

    if (ios == true) {
        params = GenerateParams("paging", this.loadCount + 2 /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    }
    else {
        params = GenerateParams("paging", (parseInt(currentPage) + 1) /*this.loadCount + 2*/); // Sayfalama için istek parametresi üretir
    }

    if (params) {
        var landingPar = getLandingParameter();

        if (landingPar) {
            return landingPar + "&" + params;
        }
        else {
            return "?" + params;
        }
    }
}

function InfinityScroll() {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var history = 'push';

    if (ios == true) {
        history = false;
    }

    var $container = $('.ProductList').infiniteScroll({
        path: getPenPath,
        append: '.Prd',
        button: '.load-more-btn',
        scrollThreshold: false,
        //checkLastPage: ".pageEnd",
        checkLastPage: '.load-more-btn',
        history: history
    });

    var infScroll = $container.data('infiniteScroll');

    $container.on('load.infiniteScroll', function () {
        setTimeout(function () {
            LazyLoad();

            var cookieGrid = $.cookie(gridCookieName);
            if (isMobileResolution()) {
                MobileGridSet(cookieGrid);
            }
            else {
                DesktopGridSet(cookieGrid);
            }

        }, 2000);
    });
}

$(document).ready(function () {

    var PageType = $("#PgType").val();

    if (PageType == "Cat" || PageType == "Combine") {

        var InfinityScroll = $("#IsInfinity").val();

        if (InfinityScroll == "True") {
            var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            var history = 'push';

            if (ios == true) {
                history = false;
            }

            $container = $('.ProductList').infiniteScroll({
                path: getPenPath,
                append: '.Prd',
                button: '.load-more-btn',
                scrollThreshold: false,
                //checkLastPage: ".pageEnd",
                checkLastPage: '.load-more-btn',
                history: history
            });

            var infScroll = $container.data('infiniteScroll');

            $container.on('load.infiniteScroll', function () {
                setTimeout(function () {
                    LazyLoad();

                    var cookieGrid = $.cookie(gridCookieName);
                    if (isMobileResolution()) {
                        MobileGridSet(cookieGrid);
                    }
                    else {
                        DesktopGridSet(cookieGrid);
                    }
                }, 1000);
            });
        }
        else {
            BackButtonLastScroll(); // Detaydan Listeleme Sayfasına Geri Dönmede Scroll Position'ı Ayarlar
        }

        // Left/Filter Bar
        ToggleLeftBar();
        SetPriceSlider();
        QuickLook();

        LazyLoad(); // Lazy Load    
        SetGridByCookie(); // Cookie Değerine Göre Grid Ayarlama
        ClearAllFilter("false");
        QueryStringControlForFilter(); // QueryString'deki filtreleri kontrol eder

        if (!isMobileResolution()) {
            $(document).on("click", "#Colors > li label, #Sizes > li label, #Properties > li label, #Cloth > li label, #ProductGroup > li label, #Departments > li label, #Seasons > li label", function () {
                FilterItemSelect($(this).parent());
                GetPageByFilter();
            });
        }
        else {
            //$(".CatBannerContainer").remove();

            // Backdrop tıklanınca filtre&sıralama alanı kapatılsın
            $(document).on("click", ".backdrop", function () {
                $(".mobilFilterArea").removeClass("open");
                $(".backdrop").removeClass("openFilter").removeClass("rightMenu");
                $("body").removeClass("no-scroll");

                if (isMobileResolution()) {
                    setTimeout(function () {
                        $(".mobilFilterArea .FilterForm .SortBodySortContainer .filterLink").addClass("toggle-minus");
                        $(".mobilFilterArea .FilterForm .SortBodySortContainer .FilterBoxes").removeClass("active");
                    }, 300);
                }
            });

            $(document).on("click", ".FilterArea .mobilFilterArea .MobilFilterHeader .headertitle i", function () {
                $(".mobilFilterArea").removeClass("open");
                $(".backdrop").removeClass("openFilter").removeClass("rightMenu");
                $("body").removeClass("no-scroll");

                setTimeout(function () {
                    $(".mobilFilterArea .FilterForm .SortBodySortContainer .filterLink").addClass("toggle-minus");
                    $(".mobilFilterArea .FilterForm .SortBodySortContainer .FilterBoxes").removeClass("active");
                }, 300);
            });

            // Mobil filtre geri kaydırma
            $(document).on("click", ".FilterForm .FilterBoxes .MobileFilterHeader a", function () {
                $(this).closest(".FilterOption").removeClass("active");
                $(this).closest(".SortBodySortContainer").children(".filterLink").addClass("toggle-minus");
            });

            $(document).on("click", "#Colors > li label, #Sizes > li label, #Properties > li label, #Cloth > li label, #ProductGroup > li label, #Departments > li label, #Seasons > li label", function () {
                FilterItemSelect($(this).parent());
            });
        }

        BrowserBackAndPrevButtonControl(); // Browser iler/geri tuşları tetiklenince çalışır

        if ($(".ProductList.NotFoundContainer .NotFound").length > 0) {
            var LastVisitedPrds = GetLastVisitedData();

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {
                GetLastVisitedPrdView(LastVisitedPrds, function (dt) {
                    if (dt != "") {
                        $(".SuggestedProductsContainer .AutoGetLastVisited").append(dt);
                        //SlickSlider("suggested");
                        $(".UseLazyLoadSuggested").Lazy();
                    }
                });
            }
        }       
    }

    // #region Ürünler
    $(document).on("click", ".ProductList .Prd .AddToCartArea button.AddToCart", function () {
        $basketButton = $(this);
        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var LangID = $("#SmallLangCode").val();

        if (!$basketButton.hasClass("passive")) {
            if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "" && SizeID != "0" && ColorID != "0" && ProductID != "0") {
                var param = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + 1 + "&langID=" + LangID;

                GenerateLocalLoading($basketButton.parents(".Prd"), "show");
                AddToCard(param, function (dt) {

                    if (dt.Sonuc == true) {
                        GetSepetIcerik(function (dt) {
                            setTimeout(function () {
                                $basketButton.closest("div.AddToCartArea").children(".TransformContainer").removeClass("select-size");
                            }, 500);

                            $basketButton.attr("data-sizeid", "0");
                            $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html("");

                            $("#UserAndBasket").html(dt);
                            if ($(window).width() > 991) {
                                toggleBasket(true);

                                // 5 sn. sonra kapansın                                
                                setTimeout(function () {
                                    if ($("body").hasClass("BasketDropped")) {
                                        toggleBasket();
                                    }
                                }, 5000);
                            }

                            //BasketAddMessage();

                            GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                        });
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                        GenerateLocalLoading($basketButton.parents(".Prd"), "hide");
                    }
                });
            }
            else if (SizeID === "0" && $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").html() === "") {
                var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;
                GetSizeOfColor(params);
            }
        }

        return false;
    });

    $('.ProductListSizeContainer div.ProductListSize:not(.passive)').live("click", function () {
        var $currentColor = $(this);
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");
        $currentColor.addClass("active");
        $currentColor.closest(".Prd").find(".AddToCart").click();
    });

    $(".ProductList .Prd").live({
        mouseleave:
            function () {
                $(this).find(".AddToCartArea .TransformContainer").removeClass("select-size");
                //$(this).find(".AddToCartArea .TransformContainer .button-container .AddToCart").removeClass("passive");
                $(this).find(".AddToCartArea .ProductListSizeContainer").html("");
            }
    });

    $(document).on("click", ".ProductListColorContainer div.ProductListColor:not(.passive):not(.active)", function () {
        var currentColor = $(this);

        currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");
        currentColor.addClass("active");

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var params = "ColorID=" + colorID + "&ProductID=" + productID;

        GetImageOfColors(params, item_unique_id, currentColor);
    });

    $('.ProductList .Prd').live("click", function (e) {
        var ScrollContentID = "LastScrollTop" + $("#PID").val();
        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });
    });
    // #endregion End Ürünler    

    // Tüm Filtreleri Kaldırır
    $(".SelectedFilter .ClearAllFilter").live("click", function () {
        ClearAllFilter("true");
    });
    
    // Sıralama
    $('#PrdSort > li input').click(function (event) {
        ProductSort($(this));
    });

    // Desktop Grid Seçimi
    $(".GridIcons > .mGridIcons").click(function () {
        var gridID = $(this).attr("data-gridvalue");

        if (gridID != null && gridID != undefined && gridID != "") {
            DesktopGridSet(gridID);
        }
    });

    // Mobile Grid Seçimi
    $(".gridAyarla").click(function () {
        if (isMobileResolution()) {
            var gridID = $(this).attr("data-grid");
            cookieGrid = $.cookie(gridCookieName);

            if (gridID != null && gridID != undefined && gridID != "") {
                MobileGridSet(gridID);
                $.cookie(gridCookieName, gridID, { path: '/' });
            }
        }
    });

    // Yeni Açının Çağrılması
    $(document).on("slid.bs.carousel", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        var ImageSrc = $(this).find(".carousel-item.active").find("img").attr("src");
        $nextOrPrevImage = $(this).find(".carousel-item.active").find("img");

        if (ImageSrc != undefined && ImageSrc.indexOf("lazy_back_new.jpg") != -1) {
            $nextOrPrevImage.attr("src", $nextOrPrevImage.attr("data-img"));
        }
    });

    $(document).on("swiperight", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        $(this).carousel('prev');
    });

    $(document).on("swipeleft", ".ProductList .Prd .PrdImgsBox .carousel", function () {
        $(this).carousel('next');
    });

    // Paging İsteği
    $(".Pages a:not(.load-more-btn), #nextPage a").live("click", function () {
        var pageNo = $(this).attr("data-pgno");

        $.cookie("lastScroll", 0, { path: '/', expires: date });
        $.cookie("getLastScrollFirst", 0, { path: '/', expires: date });

        if (pageNo != null && pageNo != undefined && pageNo != "") {
            getPageByPageNo(pageNo, "false");
        }
    });

    // Ürün'e Tıklandığında Scroll Position Alınır
    $(".ProductList a img:not(.NextPageImg)").live("click", function () {
        var lastScroll = $(window).scrollTop();
        var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur

        if (NativeQueryFilter.indexOf("=") != "-1") {
            $.cookie("lastScroll", lastScroll, { path: '/', expires: date });
        }
        else {
            $.cookie("getLastScrollFirst", lastScroll, { path: '/', expires: date });
        }
    });

    // Filtreleme İsteği
    $(".AppylArea .FilterApplyButton").live("click", function () {
        GetPageByFilter();
    });

    // Kategori Açıklama Yazısını Gösterir
    $('.CatShowMore, .CatShowLess').on('click', function (e, index) {
        var Clicked = $(this).attr("class");
        CatDescShowOrHide(Clicked);
    });

    // Mobil İçin Filtre ve Sıralama Alanını Açar
    $(".OpenFilterOrSortArea").click(function () {
        MobilSortFilterAreaOpenOrClose(".mobilFilterArea");
    });

    // Filter Search
    $(".SearchInList .SearchFilter").keyup(function () {
        var input, filter, txtValue, li;
        input = $(this).val();
        filter = input.toLocaleLowerCase();
        li = $(this).parents(".First").find(".FilterOption > ul > li");

        li.each(function (index) {
            txtValue = $(this).find("input[type='checkbox']").first().attr("data-rel");

            if (txtValue.toLocaleLowerCase().indexOf(filter) > -1) {
                $(this).css("display", "block");
            } else {
                $(this).css("display", "none");
            }
        });
    });
});

function QuickLook() {
    $(document).on("click", ".ProductList .Prd .QuickShop, .HomeProducts .Prd .QuickShop", function () {
        var ProductID = $(this).attr("data-productid");
        var ColorID = $(this).attr("data-colorid");

        if (ProductID != undefined && ProductID > 0
            && ColorID != undefined && ColorID > 0) {

            GetQuickShop(ProductID, ColorID, function (status, data) {
                if (status == false) {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                }
                else {
                    CreateModal("QuickLookModal", "modal-xl");

                    $(".QuickLookModal .modal-content").html(data);
                    $(".QuickLookModal").modal("show");   

                    SizeChart();
                }
            });
        }
    });

    $(document).on("hidden.bs.modal", ".QuickLookModal", function (e) {
        //$(".QuickLookModal .modal-content").html("");
        $(".QuickLookModal").remove();
    });

    $(document).on("shown.bs.modal", ".QuickLookModal", function (e) {
        SlickSlider("quickLook");
    });

    //SEPETE EKLE
    $(document).on("click", ".QuickLook .BasktButtons #Basket", function () {
        var SizeID = $(".QuickLook #SizeID").val();
        var ColorID = $(".QuickLook #ColorID").val();
        var ProductID = $(".QuickLook #ProductID").val();
        var Amount = 1;
        var LangID = $("#LangID").val();

        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            GenerateLocalLoading($(".QuickLookModal"), "show");

            AddToCard(data, function (dt) {
                if (dt.Sonuc == true) {
                    GetSepetIcerik(function (dt) {
                        $(".QuickLookModal").modal("hide");
                        $("#UserAndBasket").html(dt);
                        toggleBasket();
                    });
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                }

                GenerateLocalLoading($(".QuickLookModal"), "hide");
            });
        }
        else {
            if (ProductID == undefined || ProductID == "") {
                SwalGenerate("error", UrunYok, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
            else if (SizeID == undefined || SizeID == "") {
                SwalGenerate("error", BedenSec, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
            else if (ColorID == undefined || ColorID == "") {
                SwalGenerate("error", RenkSec, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
        }

        return false;
    });

    //Ürün Beden Seçimi
    $(document).on("click", ".QuickLook .SizeOptions a:not(.NotifyWhen)", function () {
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parents(".SizeOptions").find("a").removeClass("active");
        $(this).parents(".SizeOptions").find("span").removeClass("active");
        $(this).addClass("active");
        $(this).parent().addClass("active");
    });
}

// Kategori Açıklama Yazısını Açıp/Kapatır
function CatDescShowOrHide($event) {
    if ($event != null && $event != "" && $event != undefined) {
        if ($event == "CatShowMore") {
            $(".CatShowMore").hide();
            $('.CatShowLess').show();
            $('.CatSecondPart').show();
            $('.CatShortPart').hide();
        }
        else {
            $(".CatShowLess").hide();
            $('.CatShowMore').show();
            $('.CatSecondPart').hide();
            $('.CatShortPart').show();
        }
    }
}

// Filteleri seçili yapar
function FilterItemSelect(GroupName) {
    li = GroupName;

    li.toggleClass("selected");
    li.find("label").toggleClass("c_on");

    if (li.find("input").prop("checked") == true) {
        li.find("input").prop("checked", false);
    }
    else {
        li.find("input").prop("checked", true);
    }

    // $li.find("input").trigger("change");
}

// Sıralama Seçeneğini Kontrol Eden Fonksiyon
function ProductSort($selectedSort) {

    $li = $selectedSort.parent();

    // Tüm seçenekleri kapatır
    $("#PrdSort li").removeClass("selected");
    $("#PrdSort input").removeAttr("checked");
    $("#PrdSort label").removeClass("checked");
    $("#PrdSort label").removeClass("c_on");

    // Kullanıcının istediği seçeneği seçili yapar
    $li.find("label").addClass("checked");
    $li.find("label").addClass("c_on");

    // Sıralama ekranını kapatır
    $li.addClass("selected");
    //$(".fLinkSortNo").removeClass("toggle-minus");
    //$("#PrdSort").parent().hide();

    $(".fLinkSortNo").html("<i class='sorsfont sorsfont-slide-bar'></i>" + $li.find("label .checkText").html()); // Seçili sıralama seçeneğini gösterir

    var currentPage = "1";

    if ($("#IsInfinity").val() == "False") {
        currentPage = $(".Pages a.selected").attr("data-pgno"); // Kullanıcının bulunduğu sayfa alınır
    }

    if (!isMobileResolution()) {
        getPageByPageNo(currentPage, "false");
    }

    //if (isMobileResolution()) {
    //    MobilSortFilterAreaOpenOrClose(".MobilSortArea");
    //}
}

// Desktop Grid Seçim Fonksiyonu
function DesktopGridSet($gridSize) {

    var removeClass = "";
    var addClass = "";
    var ActiveIcons = "";
    var PasiveIcons = "";
    var AddToCartAreaWidth = "";
    var gridValue = "";
    var selectedGridClass = "";
    var deSelectedGridClass = "";
    var PageType = $("#PgType").val();

    if ($gridSize == "5") {
        removeClass = "triple";
        addClass = "";
        ActiveIcons = "grid-color";
        PasiveIcons = "sorsfont-5-grid";
        AddToCartAreaWidth = "92%";
        gridValue = "5";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-3";
        deSelectedRemoveIcons = "grid-color";
        deSelectedAddIcons = "sorsfont-3-grid";
    }
    else {
        removeClass = "";
        addClass = "triple";
        ActiveIcons = "grid-color";
        PasiveIcons = "sorsfont-3-grid";
        AddToCartAreaWidth = "96%";
        gridValue = "3";
        selectedGridClass = ".mGridIcons-" + gridValue;
        deSelectedGridClass = ".mGridIcons-5";
        deSelectedRemoveIcons = "grid-color";
        deSelectedAddIcons = "sorsfont-5-grid";
    }


    if (PageType != null && PageType != "" && PageType != undefined && PageType != "Combine") {
        $(".PrdContainer .ProductList").removeClass(removeClass).addClass(addClass);

        $(selectedGridClass).find(".sorsfont ").addClass(ActiveIcons).removeClass(PasiveIcons);
        $(deSelectedGridClass).find(".sorsfont ").removeClass(deSelectedRemoveIcons).addClass(deSelectedAddIcons);
    }
    else if (PageType != "Combine") {
        //$(".PrdContainer .ProductList .Prd").addClass("col-lg-8 col-xl-8");
    }

    $.cookie(gridCookieName, gridValue, { path: '/' });
}

// Mobile Grid Seçim Fonksiyonu
function MobileGridSet($gridSize) {
    $(".gridAyarla i").removeClass("grid-color");

    if ($gridSize == "5") {
        $(".PrdContainer .ProductList").removeClass("triple");
        //$(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "75%");
        $(".gridAyarla.grid2 i").addClass("grid-color");
    }
    else {
        $(".PrdContainer .ProductList").addClass("triple");
        //$(".PrdContainer .ProductList .Prd .carousel .carousel-indicators").css("left", "85%");
        $(".gridAyarla.grid1 i").addClass("grid-color");
    }
}

// Paging İçin Ajax
function getPageByPageNo(pageNo, IsBack) {
    if (pageNo == null || pageNo == "" || pageNo == undefined || pageNo == "0") {
        return false;
    }

    var params = GenerateParams("paging", pageNo); // Sayfalama için istek parametresi üretir

    GetPageAndFilter(params, function (status, data) {
        if (status == true) {
            if (IsBack == "false") {
                GenerateUrlHistoy(); // URL History oluşturur
            }

            SetUrl(params);

            if ($(".ProductList .NotFound").length === 0) {
                var IsInfinity = $("#IsInfinity").val();

                if (IsInfinity == "True") {
                    $container.infiniteScroll('destroy');
                    $(".Products").html(data);
                    InfinityScroll();
                    LazyLoad();
                }
                else {
                    $(".PageArea").remove();
                    $(".Products").append(data);
                    LazyLoad();
                }

                var cookieGrid = $.cookie(gridCookieName);

                if (isMobileResolution()) {
                    $(".mobilFilterArea").removeClass("open");
                    $(".backdrop").removeClass("rightMenu");
                    $("body").removeClass("no-scroll");
                    MobileGridSet(cookieGrid);
                    GetSelectedFilter();

                    setTimeout(function () {
                        $(".mobilFilterArea .FilterForm .SortBodySortContainer .filterLink").addClass("toggle-minus");
                        $(".mobilFilterArea .FilterForm .SortBodySortContainer .FilterBoxes").removeClass("active");
                    }, 300);
                }
                else {
                    DesktopGridSet(cookieGrid);
                }

            }
        }
    });
}

// Filter İçin Ajax
function GetPageByFilter() {
    var params = GenerateParams("filter"); // Filtreleme için istek parametresi üretir

    GetPageAndFilter(params, function (status, data) {
        if (status == true) {
            $('html, body').animate({ // Listenin başına döndürür
                scrollTop: $(".CategoryLeftBar").offset().top - 100
            }, 0);

            SetUrl(params);

            if ($(".ProductList .NotFound").length === 0) {
                var IsInfinity = $("#IsInfinity").val();

                if (IsInfinity == "True") {
                    $container.infiniteScroll('destroy');
                    $(".Products").html(data);
                    InfinityScroll();
                    LazyLoad();
                }
                else {
                    $(".Products").html(data);
                    LazyLoad();
                }                

                var cookieGrid = $.cookie(gridCookieName);                

                if (isMobileResolution()) {
                    $(".mobilFilterArea").removeClass("open");
                    $(".backdrop").removeClass("rightMenu");
                    $("body").removeClass("no-scroll");
                    MobileGridSet(cookieGrid);
                    GetSelectedFilter();

                    setTimeout(function () {
                        $(".mobilFilterArea .FilterForm .SortBodySortContainer .filterLink").addClass("toggle-minus");
                        $(".mobilFilterArea .FilterForm .SortBodySortContainer .FilterBoxes").removeClass("active");
                    }, 300);
                }
                else {
                    DesktopGridSet(cookieGrid);
                }
            }

            if ($(".SuggestedProductsContainer").length > 0) {
                SetLastVisitedProductsStorage();
            }
        }
    });
}

// Filtreleme Ve Sayfalama İsteklerinde Parametre Oluşturur
function GenerateParams($action, $pageNo) {
    var params = "";

    if ($action != null && $action != "" && $action != undefined) {

        // Sayfa Numarasını Ayarlar
        if ($action == "paging") {
            params = "p=" + $pageNo;
        }
        else if ($action == "filter") {
            params = "p=1";
        }
        // Sayfa Numarasını Ayarlar

        var CatalogPart = "&ct=" + $("#PID").val(); // Catalog ID'sini alır

        if ($("#ProductGroup li.selected").length > 0) {
            CatalogPart = "&ct=";

            $("#ProductGroup li.selected").each(function (index) {
                CatalogPart += $(this).children("input").val() + ",";
            });

            CatalogPart = CatalogPart.substring(0, CatalogPart.length - 1);
        }

        params += CatalogPart;

        // Departman Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedDepartment = "";
        $("#Departments li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedDepartment += $(this).children("input").val() + ",";
        });

        if (SelectedDepartment != "" && SelectedDepartment != null && SelectedDepartment != undefined) {
            params += "&dp=" + SelectedDepartment.substring(0, SelectedDepartment.length - 1); // Substring ile sondaki virgül silinir
        }
        // Departman Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Sezon Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSeason = "";
        $("#Seasons li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedSeason += $(this).children("input").val() + ",";
        });

        if (SelectedSeason != "" && SelectedSeason != null && SelectedSeason != undefined) {
            params += "&sea=" + SelectedSeason.substring(0, SelectedSeason.length - 1); // Substring ile sondaki virgül silinir
        }
        // Sezon Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Cookide kayıtlı grid değeri varsa onu ekler
        cookieGrid = $.cookie(gridCookieName);
        if (cookieGrid != null && cookieGrid != "" && cookieGrid != undefined) {
            params += "&g=" + cookieGrid;
        }
        // Cookide kayıtlı grid değeri varsa onu ekler

        // Tükenenleri Gizle Seçeneğini Kontrol Eder
        var SoldOut = $("#SoldOutOp li input").val();
        if (SoldOut == "1") {
            params += "&so=" + SoldOut;
        }
        // Tükenenleri Gizle Seçeneğini Kontrol Eder

        // Sıralama Seçeneğini Kontrol Eder
        $PrcSort = $("#PrdSort > li > label.checked");
        var SelectedSortID = $PrcSort.parent().children("input").val();
        if (SelectedSortID != null && SelectedSortID != "" && SelectedSortID != undefined) {
            params += "&o=" + SelectedSortID;
        }
        // Sıralama Seçeneğini Kontrol Eder

        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedColors = "";
        $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür
            SelectedColors += $(this).children("input").val() + ",";
        });

        if (SelectedColors != "" && SelectedColors != null && SelectedColors != undefined) {
            params += "&c=" + SelectedColors.substring(0, SelectedColors.length - 1); // Substring ile sondaki virgül silinir
        }
        // Color Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedSizes = "";
        $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedSizes += $(this).children("input").val() + ",";
        });

        if (SelectedSizes != "" && SelectedSizes != null && SelectedSizes != undefined) {
            params += "&s=" + SelectedSizes.substring(0, SelectedSizes.length - 1); // Substring ile sondaki virgül silinir
        }
        // Size Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedProperties = "";
        $("#Properties li.selected").each(function (index) { // Seçili özellikleri döndürür
            SelectedProperties += $(this).children("input").val() + ",";
        });

        if (SelectedProperties != "" && SelectedProperties != null && SelectedProperties != undefined) {
            params += "&prp=" + SelectedProperties.substring(0, SelectedProperties.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Kumaş Filtresini kontrol Eder, Varsa Params Değerine Ekler
        var SelectedCloth = "";
        $("#Cloth li.selected").each(function (index) { // Seçili bedenleri döndürür
            SelectedCloth += $(this).children("input").val() + ",";
        });

        if (SelectedCloth != "" && SelectedCloth != null && SelectedCloth != undefined) {
            params += "&clh=" + SelectedCloth.substring(0, SelectedCloth.length - 1); // Substring ile sondaki virgül silinir
        }
        // Özellik Filtresini kontrol Eder, Varsa Params Değerine Ekler

        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
        if ($("#SliderValue").val() != null && $("#SliderValue").val() != "" && $("#SliderValue").val() != undefined && $("#SliderValue").val() != "0-500") {
            params += "&prc=" + $("#SliderValue").val();
        }
        // Price Filtresini kontrol Eder, Varsa Params Değerine Ekler
    }

    return params;
}

function SetUrl(params) {
    var ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var newURL = location.pathname + "?" + params;

    if (ios == false) {
        window.history.replaceState({}, "", newURL); // Sayfa URL'inin değişmesini sağlar
    }
    else {
        history.pushState({}, "", newURL);
    }
}

// Sayfalama İşleminden Önce URL History Oluşturur
function GenerateUrlHistoy() {

    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // Var olan QueryString'i okur
    var PathName = window.location.pathname; // Bulunan kataloğun url'ini alır
    var CurrentURL = "";

    if (getQueryFilter.indexOf("=") != "-1") {
        CurrentURL = PathName + "?" + getQueryFilter;
    }
    else {
        CurrentURL = PathName;
    }

    if (CurrentURL != null && CurrentURL != "" && CurrentURL != undefined) {
        window.history.pushState('', '', CurrentURL);
    }
}

// Sayfalar Arası Gezerken Browser Back/Prev Butonlarını Kontrol Eder
function BrowserBackAndPrevButtonControl() {
    $(window).on('popstate', function (event) {

        var vars = [], hash;
        var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        var IsCatalogFirsPage = true;

        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "p") {
                getPageByPageNo(hash[1], "true");
                IsCatalogFirsPage = false;
            }
        }

        if (IsCatalogFirsPage == true) {
            getPageByPageNo(1, "true");
        }

    });
}

// Seçili Filtreleri Ekler
function GetSelectedFilter() {
    var SelectedFilterBody = $(".SelectedFilter");
    SelectedFilterBody.html("");
    var FilterCount = 0;

    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#ProductGroup li.selected").each(function (index) { // Seçili renkleri döndürür
        //$li = "<li>";
        //$li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='ProductGroup'></span>";
        //$li += $(this).children("input").attr("data-rel");
        //$li += "</li>";

        //SelectedFilterBody.append($li);

        FilterCount++;       
    });
    // Ürün Grubu Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Departman Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Departments li.selected").each(function (index) { // Seçili renkleri döndürür
        //$li = "<li>";
        //$li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Department'></span>";
        //$li += $(this).children("input").attr("data-rel");
        //$li += "</li>";

        //SelectedFilterBody.append($li);

        FilterCount++;   
    });
    // Departman Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Sezon Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Seasons li.selected").each(function (index) { // Seçili renkleri döndürür
        //$li = "<li>";
        //$li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='Season'></span>";
        //$li += $(this).children("input").attr("data-rel");
        //$li += "</li>";

        //SelectedFilterBody.append($li);

        FilterCount++; 
    });
    // Sezon Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Colors li.selected").each(function (index) { // Seçili renkleri döndürür
        //$li = "<li>";
        //$li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='color'></span>";
        //$li += $(this).children("input").attr("data-rel");
        //$li += "</li>";

        //SelectedFilterBody.append($li);

        FilterCount++; 
    });
    // Color Filtresini Kontrol Eder, Varsa Seçili Filtrelere Ekler

    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    $("#Sizes li.selected").each(function (index) { // Seçili bedenleri döndürür
        //$li = "<li>";
        //$li += "<span class='SelectedFilterCancelIcon' data-value='" + $(this).children("input").val() + "' data-type='size'></span>";
        //$li += $(this).children("input").attr("data-rel");
        //$li += "</li>";

        //SelectedFilterBody.append($li);

        FilterCount++; 
    });
    // Size Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    
    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler
    var PriceSlide = $("#SliderValue").val();
    if (PriceSlide != "0-500" && PriceSlide != null && PriceSlide != "" && PriceSlide != undefined) {
        //$li = "<li>";
        //$li += "<span class='SelectedFilterCancelIcon' data-value='" + $PriceSlide + "' data-type='price'></span>";
        //$li += $PriceSlide;
        //$li += "</li>";

        //SelectedFilterBody.append($li);

        FilterCount++; 
    }
    // Price Filtresini kontrol Eder, Varsa Seçili Filtrelere Ekler 

    if (FilterCount > 0) {
        SelectedFilterBody.html("<span class='ClearAllFilter'>" + getStandartMessages("FiltreleriTemizle") + " (" + FilterCount + ")</span>");
    }
}

// Tüm Filtreleri Kaldıran Fonksiyon
function ClearAllFilter(IsReload) {
    // Color filtrelerini kaldırır
    $("#Colors li input").removeAttr("checked");
    $("#Colors li label").removeClass("c_on");
    $("#Colors li input").parent("li").removeClass("selected");

    // Ürün Grubu filtrelerini kaldırır
    $("#ProductGroup li input").removeAttr("checked");
    $("#ProductGroup li label").removeClass("c_on");
    $("#ProductGroup li input").parent("li").removeClass("selected");

    // Departman filtrelerini kaldırır
    $("#Departments li input").removeAttr("checked");
    $("#Departments li label").removeClass("c_on");
    $("#Departments li input").parent("li").removeClass("selected");

    // Sezon filtrelerini kaldırır
    $("#Seasons li input").removeAttr("checked");
    $("#Seasons li label").removeClass("c_on");
    $("#Seasons li input").parent("li").removeClass("selected");

    // Size filtrelerini kaldırır
    $("#Sizes li input").removeAttr("checked");
    $("#Sizes li label").removeClass("c_on");
    $("#Sizes li input").parent("li").removeClass("selected");

    // Price filtresini kaldırır
    $("#MinPrice").val("0");
    $("#MaxPrice").val("500");
    $("#SliderValue").val("0-500");

    var slider = $('#PriceSlider');

    if (IsReload == "true") {
        GetPageByFilter(); // Filtreleri temizledikten sonra istek yapar
    }
}

// Mobil Filtre ve Sıralama Alanını Aldığı Değere Göre Açıp/Kapatan Fonksiyon
function MobilSortFilterAreaOpenOrClose($AreaName) {
    $($AreaName).addClass("open");
    $(".backdrop").addClass("rightMenu");
    $("body").addClass("no-scroll");
}

